module.exports = (__webpack_require__(3610))(40961);